import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constant/colors";

const Schooldata = () => {
  const [formData, setFormData] = useState({
    schoolName: "",
    schoolCode: "",
    phone1: "",
    phone2: "",
    email1: "",
    email2: "",
    address: "",
    logo: null,
    website: "",
    instagram: "",
  facebook: "",
  twitter: "",
  youtube: "",
  });

  const [schools, setSchools] = useState([]);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState("");
const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchSchools();
  }, []);

  const fetchSchools = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/school/getSchool`);
      setSchools(res.data);
    } catch (error) {
      console.error("Failed to fetch school data", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, logo: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
setIsSubmitting(true);
    const form = new FormData();
    Object.entries(formData).forEach(([key, val]) => form.append(key, val));

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/school`, form, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("School information submitted!");
      resetForm();
      fetchSchools();
    } catch (error) {
      console.error(error);
      setMessage("Failed to submit school information.");
    } finally {
    setIsSubmitting(false); 
  }
  };

  const handleUpdate = async (id) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/school/${id}`);
      setFormData({
  ...res.data,
  logo: null // file inputs must be reset
});
      setEditId(id);
    } catch (error) {
      console.error("Failed to load update data", error);
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
setIsSubmitting(true);
    const form = new FormData();
    Object.entries(formData).forEach(([key, val]) => form.append(key, val));

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/school/updateSchool/${editId}`,
        form,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      alert("School information updated!");
      resetForm();
      fetchSchools();
    } catch (error) {
      console.error(error);
      setMessage("Failed to update school.");
    } finally {
    setIsSubmitting(false);
  }
  };

  const resetForm = () => {
    setFormData({
      schoolName: "",
      schoolCode: "",
      phone1: "",
      phone2: "",
      email1: "",
      email2: "",
      address: "",
      logo: null,
      website: "",
      instagram: "",
    facebook: "",
    twitter: "",
    youtube: "",
    });
    setEditId(null);
  }

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg text-[14px]">

  

      <hr className="mb-6" />

      {/* FORM CARD */}
      <div className="w-full bg-white shadow-md border rounded-lg p-6 mb-10">

        {/* Form Title */}
        <h2
          className="text-[18px] font-bold mb-6 text-center"
          style={{
            background: colors.gradientPrimary,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {editId ? "Update School Details" : "Add School Details"}
        </h2>

        {message && (
          <p className="text-red-600 text-center mb-4 text-[14px]">{message}</p>
        )}

        <form
          className="space-y-6"
          onSubmit={editId ? handleUpdateSubmit : handleSubmit}
        >
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input label="School Name" name="schoolName" value={formData.schoolName} onChange={handleInputChange} required />
            <Input label="School Code" name="schoolCode" value={formData.schoolCode} onChange={handleInputChange} required />

            <Input label="Phone Number 1" name="phone1" value={formData.phone1} onChange={handleInputChange} required />
            <Input label="Phone Number 2" name="phone2" value={formData.phone2} onChange={handleInputChange} />

            <Input label="Email 1" name="email1" type="email" value={formData.email1} onChange={handleInputChange} required />
            <Input label="Email 2" name="email2" type="email" value={formData.email2} onChange={handleInputChange} />
          </div>

          <TextArea label="Address" name="address" value={formData.address} onChange={handleInputChange} required />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input label="School Logo" name="logo" type="file" onChange={handleFileChange} />
            <Input label="Website" name="website" value={formData.website} onChange={handleInputChange} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  <Input
    label="Instagram"
    name="instagram"
    value={formData.instagram}
    onChange={handleInputChange}
    placeholder="https://instagram.com/yourpage"
  />

  <Input
    label="Facebook"
    name="facebook"
    value={formData.facebook}
    onChange={handleInputChange}
    placeholder="https://facebook.com/yourpage"
  />

  <Input
    label="Twitter / X"
    name="twitter"
    value={formData.twitter}
    onChange={handleInputChange}
    placeholder="https://x.com/yourpage"
  />

  <Input
    label="YouTube"
    name="youtube"
    value={formData.youtube}
    onChange={handleInputChange}
    placeholder="https://youtube.com/@yourchannel"
  />
</div>


          <button
  type="submit"
  disabled={isSubmitting}
  className={`w-full text-[14px] px-4 py-2 rounded-lg 
    ${isSubmitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700 text-white"}
  `}
>
  {isSubmitting
    ? "Submitting..."
    : editId
      ? "Update"
      : "Submit"}
</button>

        </form>
      </div>

      {/* SCHOOL LIST */}
      <div className="w-full bg-white shadow-md border rounded-lg p-6">

        <h2
          className="text-[18px] font-bold mb-6 text-center"
          style={{
            background: colors.gradientPrimary,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          School Records
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

          {schools.map((school) => (
            <div key={school._id} className="bg-white p-6 border rounded-lg shadow text-[14px]">

              <div className="flex justify-center mb-3">
                <img src={school.logo} alt="Logo" className="w-20 h-20 object-contain" />
              </div>

              <h3 className="text-[18px] font-bold text-gray-800">{school.schoolName}</h3>

              <Info label="Code" value={school.schoolCode} />
              <Info label="Phone 1" value={school.phone1} />
              <Info label="Phone 2" value={school.phone2} />
              <Info label="Email 1" value={school.email1} />
              <Info label="Email 2" value={school.email2} />
              <Info label="Address" value={school.address} />

              <p className="text-gray-700 mb-2 text-[14px]">
                <strong>Website: </strong>
                <a href={school.website} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">
                  {school.website}
                </a>
              </p>
              {school.instagram && (
  <Info label="Instagram" value={school.instagram} />
)}

{school.facebook && (
  <Info label="Facebook" value={school.facebook} />
)}

{school.twitter && (
  <Info label="Twitter / X" value={school.twitter} />
)}

{school.youtube && (
  <Info label="YouTube" value={school.youtube} />
)}


              <button
                onClick={() => handleUpdate(school._id)}
                className="bg-blue-600 text-white px-3 py-2 rounded-lg w-full mt-2 text-[14px]"
              >
                <i className="fas fa-edit mr-2"></i> Edit
              </button>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

/* COMPONENTS */
const Input = ({ label, ...props }) => (
  <div>
    <label className="text-gray-700 font-semibold mb-1 block text-[14px]">{label}</label>
    <input
      {...props}
      className="border rounded-lg px-3 py-2 w-full outline-none focus:ring-2 focus:ring-blue-500 text-[14px]"
    />
  </div>
);

const TextArea = ({ label, ...props }) => (
  <div>
    <label className="text-gray-700 font-semibold mb-1 block text-[14px]">{label}</label>
    <textarea
      {...props}
      className="border rounded-lg px-3 py-2 w-full h-24 resize-none outline-none focus:ring-2 focus:ring-blue-500 text-[14px]"
    />
  </div>
);

const Info = ({ label, value }) => (
  <p className="text-gray-700 mb-1 text-[14px]">
    <strong>{label}: </strong> {value}
  </p>
);

export default Schooldata;
